import { put, takeLatest } from "redux-saga/effects";
import { getCRMInfoApi } from "store/api/HomeApi";
import { GET_CRM_SHOP_INFO_SPLASH_ACTION } from "../../actions/HomePageAction/actionTypes";

import * as homePageAction from "../../actions/HomePageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getCRMInfoSplash(action) {
	const { token, infoDevice, onSuccess } = action?.params;
	const res = yield getCRMInfoApi(token, infoDevice);
	try {
		if (res?.code === 0) {
			const dataShop = res?.data?.shop;
			onSuccess(dataShop);
			yield put(homePageAction.setCRMShopInfoDetail(dataShop));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getCRMInfoSplashSaga() {
	yield takeLatest(GET_CRM_SHOP_INFO_SPLASH_ACTION, getCRMInfoSplash);
}

export default getCRMInfoSplashSaga;
